
export enum PageIdentity {
    Home,
    SourceSelection,
    Era,
    ToolSelection,
    CharacterType,
    Species,
    SpeciesDetails,
    CustomSpeciesDetails,
    Environment,
    EnvironmentDetails,
    Upbringing,
    UpbringingDetails,
    Career,
    CareerDetails,
    CareerLength,
    NoviceOrCadetExperience,
    CadetSeniority,
    ChildCareer,
    ChildEducationPage,
    ChildEducationDetailsPage,
    CareerLengthDetails,
    CareerEvent1,
    CareerEvent1Details,
    CareerEvent2,
    CareerEvent2Details,
    AttributesAndDisciplines,
    ExtraTalentDetails,
    Finish,

    OtherTools,
    RandomStarship,
    RandomCreature,

    ExtraStarshipTalentChoice,
    MissionProfileTalentSelection,
    MissionProfileSelection,
    MissionPodSelection,
    SimpleStarship,
    SmallCraftStats,
    SpaceframeSelection,
    StarshipRefits,
    StarshipServiceRecord,
    StarshipToolSelection,
    StarshipTypeSelection,
    StarshipTalentSelection,
    StarshipWeaponsSelection,
    FinalStarshipDetails,
    SupportingCharacter,
    TalentsOverview,

    SystemGeneration,
    SectorDetails,
    StarSystemDetails,

    CreditsPage,
    ViewSheet,

    GamemasterTrackerPage,
    XmlViewer,

    ModificationTypeSelection,
    ReputationChange,
    NormalMilestone,
    ModificationCompletePage,

    NpcConfiguration,
    NpcBuilder,
    NpcSpeciesSelection,
    NpcSpeciesSelectionDetails,
    NpcStats,
    NpcSpecialRules,
    NpcFinal,
    TokenCreationPage,

    SoloConstructType,
    SoloCharacterEra,
    SoloSpecies,
    SoloSpeciesDetails,
    SoloCustomSpeciesDetails,
    SoloEarlyOutlook,
    SoloEarlyOutlookDetails,
    SoloEducationType,
    SoloEducationPage,
    SoloEducationDetailsPage,
    SoloCareerLengthDetails,
    SoloCareerEvent1,
    SoloCareerEventDetails1,
    SoloCareerEvent2,
    SoloCareerEventDetails2,
    SoloFinishingTouches,
    SoloFinal,

    SoloStarshipEra,
    SoloStarshipSpaceframe,
    SoloStarshipTalents,
    SoloStarshipFinish,

    StationIndex,
    StationSpaceframe,
    StationMissionProfile,
    StationTalents,
    StationWeapons,
    StationFinal,

    TableList,
    ViewTable,
    ImportTable,
    EditTable,


    TacticalAssets,

    ModifySupportingCharacter,
    ModifyMainCharacter,
    ModifyStarship
}
